import { render, staticRenderFns } from "./UserChatHangout.vue?vue&type=template&id=b436d312&scoped=true&"
import script from "./UserChatHangout.vue?vue&type=script&lang=js&"
export * from "./UserChatHangout.vue?vue&type=script&lang=js&"
import style0 from "./UserChatHangout.vue?vue&type=style&index=0&id=b436d312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b436d312",
  null
  
)

export default component.exports